import { DatapointIdStandardEnum, DatapointsEntityType } from "api/ux/src";
import { addCustomFieldsAsCols, addCustomFieldsAsDatapoints } from "components/modal/portfolio-creation-edit/helper";
import { filterTagLabels } from "components/tags/helpers";
import { InsGridAggs } from "components/widgets/grid/grid-agg-funcs";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { getMeasuresAndDimensionsWithCurrency, getMeasuresAndDimensionsWithoutCurrency } from "hooks/use-funds-page";
import { useGetCustomDatapointFields } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
const { assetClass } = language.en;
const mLanguage = language.en.administration.dataAdministration.exportData.funds;
export const useMeasuresAndDimensions = (currency, groups) => {
    const customFields = useGetCustomDatapointFields([DatapointsEntityType.Fund]);
    const datapoints = [
        { datapoint: { standard: DatapointIdStandardEnum.FundFundId }, name: "Id" },
        { datapoint: { standard: DatapointIdStandardEnum.ManagerManagerId }, name: "ManagerId" },
        { datapoint: { standard: DatapointIdStandardEnum.FundAssetClass }, name: "AssetClass" },
        { datapoint: { standard: DatapointIdStandardEnum.ManagerManagerName }, name: "ManagerName" },
        { datapoint: { standard: DatapointIdStandardEnum.FundSize }, name: "Size" },
        { datapoint: { standard: DatapointIdStandardEnum.FundFundName }, name: "Name" },
        { datapoint: { standard: DatapointIdStandardEnum.FundCurrency }, name: "Currency" },
        { datapoint: { standard: DatapointIdStandardEnum.FundStrategy }, name: "Strategy" },
        { datapoint: { standard: DatapointIdStandardEnum.FundGeography }, name: "Geography" },
        { datapoint: { standard: DatapointIdStandardEnum.FundVintageYear }, name: "Vintage" }
    ];
    if (customFields) {
        addCustomFieldsAsDatapoints(customFields, datapoints);
    }
    const [fundIdDatapoint, managerIdDatapoint, ...mesureDatapoints] = datapoints;
    const { dimensions, measures } = currency
        ? getMeasuresAndDimensionsWithCurrency([...groups], mesureDatapoints)
        : getMeasuresAndDimensionsWithoutCurrency(mesureDatapoints);
    dimensions.push(managerIdDatapoint);
    dimensions.push(fundIdDatapoint);
    return { dimensions, measures };
};
export const useCreateColFunds = () => {
    const customFields = useGetCustomDatapointFields([DatapointsEntityType.Fund]);
    const assetClassCol = [];
    assetClassCol.push({
        field: assetClass.gridTitle,
        type: CustomColumnType.InsTextSetColumn
    });
    const noInvestorCols = [
        { checkboxSelection: true,
            field: "Name",
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerName: mLanguage.name,
            sort: "asc",
            type: [CustomColumnType.AUX_TEXT_COLUMN],
            width: 280 },
        { field: "AssetClass", headerName: "Asset Class", type: CustomColumnType.InsTextSetColumn, width: 140 },
        { field: "Currency", headerName: mLanguage.currency, type: CustomColumnType.InsTextSetColumn, width: 140 }
    ];
    const cols = [
        { field: "Id", hide: true, lockVisible: true },
        ...noInvestorCols,
        { field: "ManagerName", headerName: mLanguage.manager, type: CustomColumnType.InsTextSetColumn, width: 140 },
        { aggFunc: InsGridAggs.totalData, field: "Size", headerName: mLanguage.size, type: [CustomColumnType.InsMoneyColumn], width: 140 },
        { field: "Vintage", headerName: mLanguage.vintageYear, type: CustomColumnType.InsTextSetColumn, width: 140 },
        { field: "Strategy", headerName: mLanguage.strategy, type: CustomColumnType.InsTextSetColumn, width: 140 },
        { field: "Geography", headerName: mLanguage.geography, type: CustomColumnType.InsTextSetColumn, width: 140 },
        {
            enableRowGroup: true,
            field: "tags",
            filter: "agSetColumnFilter",
            filterValueGetter: filterTagLabels,
            headerName: "Tags",
            type: [CustomColumnType.InsTagsColumn]
        }
    ];
    addCustomFieldsAsCols(customFields, cols);
    return cols;
};
